import { render } from "./EWRItemElement.vue?vue&type=template&id=53b97b58&ts=true"
import script from "./EWRItemElement.vue?vue&type=script&lang=ts"
export * from "./EWRItemElement.vue?vue&type=script&lang=ts"

import "./EWRItemElement.vue?vue&type=style&index=0&id=53b97b58&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToggle,QBtn,QTooltip});
